// Global Components
import * as React from 'react';

// Components
import moment from 'moment';
import InputLabel from '../InputLabel';

// Types
import type {
  $InputProps,
} from '../../../types';

type $OptionalProps = {
  className?: string;
  disabled?: boolean;
  label?: string;
  labelClassName?: string;
  max?: Date;
  min?: Date;
  onChange?: (value: string) => unknown;
  placeholder?: string;
  required?: boolean;
  value?: null | string;
};

type $Props = $InputProps & $OptionalProps & {
  highlight: boolean;
  name: string;
};

class InputDateView extends React.Component<$Props> {
  static defaultProps: $OptionalProps = {
    className: undefined,
    disabled: undefined,
    label: undefined,
    labelClassName: undefined,
    max: undefined,
    min: undefined,
    onChange: undefined,
    placeholder: undefined,
    required: undefined,
    value: undefined,
  };

  getMinMax(): {
    max?: string;
    min?: string;
    } {
    const {
      max,
      min,
    } = this.props;

    const dateFormat = 'YYYY-MM-DD';
    const output: {
      max?: string;
      min?: string;
    } = {
      max: undefined,
      min: undefined,
    };

    if (max) {
      output.max = moment(max).format(dateFormat);
    }

    if (min) {
      output.min = moment(min).format(dateFormat);
    }

    return output;
  }

  renderInput() {
    const {
      disabled,
      highlight,
      isValid,
      name,
      onChange,
      placeholder,
      required,
      setValue,
      value,
    } = this.props;

    const {
      max,
      min,
    } = this.getMinMax();

    return (
      <input
        className={`border-${highlight && !isValid ? 'red-600' : 'gray-400'} text-sm sm:text-base placeholder-gray-600 p-2 rounded-lg border w-full focus:outline-none focus:border-blue-400`}
        disabled={disabled}
        id={name}
        max={max}
        min={min}
        name={name}
        onChange={(e) => {
          const newValue = e.currentTarget.value;

          if (onChange) {
            onChange(newValue);
          }

          setValue(newValue);
        }}
        placeholder={placeholder}
        required={required}
        style={{
          height: 42,
        }}
        type={'date'}
        value={value || undefined}
      />
    );
  }

  render() {
    const {
      className,
      label,
      labelClassName,
      name,
      required,
    } = this.props;

    return (
      <div className={`InputDate ${className || ''}`}>
        <InputLabel
          className={labelClassName}
          label={label}
          name={name}
          required={required}
        />
        {this.renderInput()}
      </div>
    );
  }
}

export default InputDateView;
